import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { Link } from "react-router-dom";
import { _Api, Api_form } from "../common/api/_call";
import TableColumnModal from "../../components/common/modules/tableColumn";
import { poscustomer_head } from "../../components/common/Tablehead";
import "react-datepicker/dist/react-datepicker.css";
import "./customer.scss";
import "../../components/common/selectbox/selectBox";
import {
  success,
  error,
  Updateloading,
  loading,
} from "../common/helpers/toastify";
import CheckoutBlank from "../checkout/checkoutBlank";
import DeleteModal from "../common/module/deletemodal";
import CustomerSearchDetailModal from "../common/module/CustomerSearchDetailModal";
import { useTranslation } from "react-i18next";
import { updateCustomer } from "../../source/app/appSlice";
import { useDispatch } from "react-redux";
import Importmodal from "../common/Modals/Importmodal";
import { Pagination } from "../common/Pagination";
import Showloader from "../common/Showloader";
import { useSelector } from "react-redux";
import Select from "react-select";
import CustomerInformation from "../../admin/customers/customerInformation/CustomerInformation";
import KycStatusIcon from "admin/customers/KycStatusIcon";
import { _WarrantyApi } from "admin/api/_call";
import { toast } from "react-toastify";
import TableActionMenu, {
  toggleTableActionMenu,
} from "../common/module/TableActionMenu";

const CUSTOMER_SORT_FIELD = {
  "#": "__idx",
  "Customer Id": "customerid",
  Name: "name",
  Group: "group",
  "Mobile Number": "phone",
  Email: "email",
  "Last Modified Date": "modified",
};

const Customer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [importfile, setImportfile] = useState();
  const [setnewcustomersid] = useState();
  const [limit, setLimit] = useState(100);
  const [Namedata, setNamedata] = useState([]);
  const [countrydata, setCountrydata] = useState([]);
  const [citydata, setCitydata] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [customerdetails, setCustomerdetails] = useState();
  const [filter, setFilter] = useState(false);
  const [cusid, setCusid] = useState();
  const [newcolumndata, setnewcolumndata] = useState(poscustomer_head);
  const [cussearchkey, setCussearchkey] = useState("");
  const alphabates = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  const [country, setCountry] = useState([]);
  const [city, setCity] = useState([]);
  const [dataloder, setDataloder] = useState(false);
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const currentPageRef = useRef(1);
  const [sortState, setSortState] = useState({ column: null, dir: "asc" });
  const [kycIntegrate, setKycIntegrate] = useState();
  const [kycLoading, setKycLoading] = useState(false);
  const kycPollRef = useRef(null);
  // { key, row, top, left, width, height } of the open row action menu.
  const [actionMenu, setActionMenu] = useState(null);
  const closeActionMenu = useCallback(() => setActionMenu(null), []);
  const visibleColumns = useMemo(
    () =>
      (Array.isArray(newcolumndata) ? newcolumndata : []).filter(
        (c) => c && c.status !== false,
      ),
    [newcolumndata],
  );

  const handleSelectAllCheckBox = (event) => {
    const checkBox = event.target;
    const raw = checkBox.getAttribute("data-select") || "";
    const childClass = "." + raw.replace("_main", "").trim();
    const allCheckbox = document.querySelectorAll(childClass);
    if (checkBox.checked === true) {
      allCheckbox.forEach((el) => {
        el.checked = true;
      });
    } else {
      allCheckbox.forEach((el) => {
        el.checked = false;
      });
    }
  };

  const sortedCustomerDetails = useMemo(() => {
    if (!customerdetails?.length) return customerdetails || [];
    const col = sortState.column;
    const field = col ? CUSTOMER_SORT_FIELD[col] : null;
    if (!field) return customerdetails;

    const rows = customerdetails.map((row, i) => ({ row, i }));
    const m = sortState.dir === "asc" ? 1 : -1;
    rows.sort((a, b) => {
      if (field === "__idx") {
        return m * (a.i - b.i);
      }
      if (field === "modified") {
        const ta = Date.parse(a.row[field]);
        const tb = Date.parse(b.row[field]);
        const va = Number.isNaN(ta) ? 0 : ta;
        const vb = Number.isNaN(tb) ? 0 : tb;
        return m * (va - vb);
      }
      const va = String(a.row[field] ?? "").toLowerCase();
      const vb = String(b.row[field] ?? "").toLowerCase();
      return (
        m *
        va.localeCompare(vb, undefined, { numeric: true, sensitivity: "base" })
      );
    });
    return rows.map((x) => x.row);
  }, [customerdetails, sortState]);

  const toggleCustomerSort = (col) => {
    if (!col?.sort) return;
    setSortState((prev) => {
      if (prev.column !== col.name) return { column: col.name, dir: "asc" };
      return { column: col.name, dir: prev.dir === "asc" ? "desc" : "asc" };
    });
  };

  useEffect(() => {
    callcolumns();
  }, []);
  const callcolumns = async () => {
    try {
      const postdata = {
        name: "tbl_pos_customerlist",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`,
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const clearall = () => {
    let get = document.getElementsByName("clear");
    for (let i = 0; i < get.length; i++) {
      get[i].checked = false;
    }
    setNamedata([]);
    setCountrydata([]);
    setCitydata([]);
  };
  const checkallName = () => {
    let allletter = document.querySelectorAll(".namescheck");
    for (let i = 0; i < allletter.length; i++) {
      allletter[i].checked = true;
    }
  };

  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 },
  ];

  const callfilters = (event, label) => {
    if (label === "name") {
      const namedata = [...Namedata];
      if (event.target.checked) {
        if (namedata.filter((e) => e === event.target.value).length === 0) {
          namedata.push(event.target.value);
          setNamedata(namedata);
        }
      } else {
        setNamedata((current) =>
          current.filter((item) => item !== event.target.value),
        );
      }
    } else if (label === "country") {
      const countryarr = [...countrydata];
      if (event.target.checked) {
        if (countryarr.filter((e) => e === event.target.value).length === 0) {
          countryarr.push(event.target.value);
          setCountrydata(countryarr);
        }
      } else {
        setNamedata((current) =>
          current.filter((item) => item !== event.target.value),
        );
      }
    } else if (label === "city") {
      const cityarr = [...citydata];

      if (event.target.checked) {
        if (cityarr.filter((e) => e === event.target.value).length === 0) {
          cityarr.push(event.target.value);
          setCitydata(cityarr);
        }
      } else {
        setNamedata((current) =>
          current.filter((item) => item !== event.target.value),
        );
      }
    }
  };

  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  });

  const { totalPages, currentPage } = state;

  useEffect(() => {
    currentPageRef.current = currentPage;
  }, [currentPage]);

  const GetcustomersDetails = useCallback(
    async (pageParam, limitOverride) => {
      const effectiveLimit =
        limitOverride != null && limitOverride !== "" ? limitOverride : limit;
      const page =
        pageParam != null && pageParam !== ""
          ? pageParam
          : currentPageRef.current;
      setDataloder(true);
      try {
        const postdata = {
          name: Namedata,
          country: countrydata,
          city: citydata,
          search: cussearchkey,
          limit: effectiveLimit,
          skip: (page - 1) * effectiveLimit,
        };
        const res = await _Api(postdata, `api/v1/Customer/customer/getList`);
        setDataloder(false);
        if (res.code === 200) {
          setCustomerdetails(res?.data);
          setstate((prev) => ({
            ...prev,
            totalPages: Math.ceil(res?.total / postdata.limit),
            currentPage: page,
          }));
          setKycIntegrate(res?.kycIntegration?.status);
        } else {
          setCustomerdetails(undefined);
        }
      } catch (err) {
        setDataloder(false);
        console.log(err, "err");
      }
    },
    [Namedata, countrydata, citydata, cussearchkey, limit],
  );

  const getlimit = (nextLimit) => {
    setLimit(nextLimit);
    setstate((prev) => ({ ...prev, currentPage: 1 }));
    GetcustomersDetails(1, nextLimit);
  };

  const handlePaginations = (current) => {
    setstate((prev) => ({ ...prev, currentPage: current }));
    GetcustomersDetails(current, undefined);
  };
  const handler_delete = async () => {
    try {
      let GetloadingID = loading();
      let postdata = {
        id: cusid,
      };
      let res = await _Api(postdata, `api/v1/APP/customer/delete`);
      if (res?.code === 200) {
        Updateloading(t, GetloadingID, res?.message);
        GetcustomersDetails();
      } else {
        Updateloading(t, GetloadingID, res.errors, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    if (!cussearchkey) {
      GetcustomersDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cussearchkey, cusid]);

  const creditfunction = (name, id) => {
    dispatch(updateCustomer({ id: id, name: name }));
    let jsondata = JSON.stringify({ id: id, name: name });
    localStorage.setItem("customerdetails", jsondata);
  };

  const readExcel = async () => {
    if (!importfile) {
      error(t("Choose file!"));
      return;
    }
    try {
      window.dispatchEvent(
        new CustomEvent("gis-customer-import", {
          detail: {
            status: "running",
            label: "Customer import",
            done: 0,
            total: 1,
          },
        }),
      );
      const formData = new FormData();
      formData.append("file", importfile);
      formData.append("type", "CustomerImport");
      let res = await Api_form(formData, `api/v1/App/customer/uploadCustomer`);
      if (res.code === 200) {
        window.dispatchEvent(
          new CustomEvent("gis-customer-import", {
            detail: {
              status: "running",
              label: "Customer import",
              done: 0,
              total: 1,
              jobId: res?.data ? String(res.data) : "",
            },
          }),
        );
        success(
          t(
            "File Sucessfully Uploaded and Backend Process have  Started Now,Please wait!!",
          ),
        );
        GetcustomersDetails();
      } else {
        error(t("Please Wait or try again later!!"));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const getcustomerfiltter = async () => {
    try {
      const postdata = {};
      let res = await _Api(postdata, `api/v1/App/customer/customerFilter`);
      if (res.code === 200) {
        setCountry(res?.data?.country);
        setCity(res?.data?.city);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getcustomerfiltter();
  }, []);

  const getscarchvalue = async (event, lable) => {
    if (lable === "country") {
      const query = searchVal
        ? searchVal
        : event.target.value
          ? event.target.value
          : "";
      let updatedList = [...country];
      let arr = [];
      if (query) {
        updatedList.forEach((item) => {
          if (item?.name.toLowerCase() === query.toLowerCase()) {
            arr.push(item);
          }
          setCountry(arr);
        });
      } else {
        getcustomerfiltter();
      }
    } else if (lable === "city") {
      const query = searchVal
        ? searchVal
        : event.target.value
          ? event.target.value
          : "";
      let updatedList = [...city];
      let arr = [];
      if (query) {
        updatedList.forEach((item) => {
          if (item.toLowerCase() === query.toLowerCase()) {
            arr.push(item);
          }
          setCity(arr);
        });
      } else {
        getcustomerfiltter();
      }
    }
  };

  const startKycPolling = () => {
    if (kycPollRef.current) clearInterval(kycPollRef.current);

    let attempts = 0;
    const MAX_ATTEMPTS = 20;

    kycPollRef.current = setInterval(async () => {
      attempts++;
      await GetcustomersDetails();

      if (attempts >= MAX_ATTEMPTS) {
        clearInterval(kycPollRef.current);
        kycPollRef.current = null;
      }
    }, 6000);
  };

  useEffect(() => {
    return () => {
      if (kycPollRef.current) clearInterval(kycPollRef.current);
    };
  }, []);

  const fetchOndatoUrl = async (id) => {
    try {
      setKycLoading(true);
      let res = await _WarrantyApi({ id }, `api/v1/APP/profile/create-kyc`);
      if (res?.success === true) {
        window.open(res?.data?.url, "_blank", "noreferrer");
        startKycPolling();
      } else {
        toast.error(
          res?.message ||
            res?.error ||
            "Something went wrong. Please try again.",
        );
      }
    } catch (err) {
      console.log(err, "err");
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to initiate KYC. Please try again.",
      );
    } finally {
      setKycLoading(false);
    }
  };
  const handleKyc = (result) => {
    if (
      !kycLoading &&
      result?.kycStatus !== "Approved" &&
      result?.kycStatus !== "Completed"
    ) {
      fetchOndatoUrl(result?._id);
    }
  };

  const renderActionMenuItems = (result) => (
    <>
      <li
        onClick={() => {
          setCusid(result?._id);
        }}
        data-bs-toggle="modal"
        data-bs-target="#customerAddModal"
      >
        <Link className="dropdown-item img-btn-hover">
          <div className="dropdown-menu-img">
            <img
              className="img-btn-hover-img-1"
              src={
                base_assets +
                "images/pos/icons/i1.png"
              }
              alt=""
            />
            <img
              className="img-btn-hover-img-2"
              src={
                base_assets +
                "images/pos/icons/i1w.png"
              }
              alt=""
            />
          </div>
          {t("Preview")}
        </Link>
      </li>
      <li
        onClick={() =>
          creditfunction(
            result?.name,
            result?._id,
          )
        }
      >
        <Link
          className="dropdown-item img-btn-hover"
          to="/app/pos/customer/paymentHistory"
        >
          <div className="dropdown-menu-img">
            <img
              className="img-btn-hover-img-1"
              src={
                base_assets +
                "images/pos/icons/i2.png"
              }
              alt=""
            />
            <img
              className="img-btn-hover-img-2"
              src={
                base_assets +
                "images/pos/icons/i2w.png"
              }
              alt=""
            />
          </div>
          {t("Payment History")}
        </Link>
      </li>
      <li
        onClick={() =>
          creditfunction(
            result?.name,
            result?._id,
          )
        }
      >
        <Link
          className="dropdown-item img-btn-hover"
          to="/app/pos/customer/purchaseHistory"
        >
          <div className="dropdown-menu-img">
            <img
              className="img-btn-hover-img-1"
              src={
                base_assets +
                "images/pos/icons/i3.png"
              }
              alt=""
            />
            <img
              className="img-btn-hover-img-2"
              src={
                base_assets +
                "images/pos/icons/i3w.png"
              }
              alt=""
            />
          </div>
          {t("Purchase History")}
        </Link>
      </li>
      <li
        onClick={() =>
          creditfunction(
            result?.name,
            result?._id,
          )
        }
      >
        <Link
          className="dropdown-item img-btn-hover"
          to="/app/pos/customer/PartialPaymentHistory"
        >
          <div className="dropdown-menu-img">
            <img
              className="img-btn-hover-img-1"
              src={
                base_assets +
                "images/pos/icons/i6.png"
              }
              alt=""
            />
            <img
              className="img-btn-hover-img-2"
              src={
                base_assets +
                "images/pos/icons/i6w.png"
              }
              alt=""
            />
          </div>
          {t("Partial Payment History")}
        </Link>
      </li>
      <li
        onClick={() =>
          creditfunction(
            result?.name,
            result?._id,
          )
        }
      >
        <Link
          className="dropdown-item img-btn-hover"
          to="/app/pos/customer/CreditNote"
        >
          <div className="dropdown-menu-img">
            <img
              className="img-btn-hover-img-1"
              src={
                base_assets +
                "images/pos/icons/i4.png"
              }
              alt=""
            />
            <img
              className="img-btn-hover-img-2"
              src={
                base_assets +
                "images/pos/icons/i4w.png"
              }
              alt=""
            />
          </div>
          {t("Credit Note")}{" "}
        </Link>
      </li>
      <li
        className={
          parmissiondatashow
            ?.pos_customer_reports
            ?.Delete
            ? "customer-table-dropdown-last-border"
            : "d-none"
        }
        data-bs-toggle="modal"
        data-bs-target="#delete-listedModal"
        onClick={() =>
          setCusid(result?._id)
        }
      >
        <Link
          className="dropdown-item img-btn-hover"
          to="#"
        >
          <div className="dropdown-menu-img">
            <img
              className="img-btn-hover-img-1"
              src={
                base_assets +
                "images/pos/icons/i5.png"
              }
              alt=""
            />
            <img
              className="img-btn-hover-img-2"
              src={
                base_assets +
                "images/pos/icons/i5w.png"
              }
              alt=""
            />
          </div>
          {t("Delete")}
        </Link>
      </li>
    </>
  );

  return (
    <>
      <div className="main-body">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div className="customer">
              <div className="customer-inner">
                <div className="customer-inner-tophead">
                  <h4 className="main-heading">{t("Customer")}</h4>
                  <div className="customer-inner-tophead-right">
                    <div className="com-search-area com-search-area-large bg-white">
                      <input
                        type="text"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            setstate((prev) => ({ ...prev, currentPage: 1 }));
                            GetcustomersDetails(1, undefined);
                          }
                        }}
                        value={cussearchkey}
                        onChange={(e) => setCussearchkey(e.target.value)}
                        placeholder={t("Search Customer")}
                      />
                      <img
                        className="com-search-area-img"
                        src={
                          base_assets + "images/pos/icons/magnifying-glass.png"
                        }
                        alt=""
                      />
                      <button
                        onClick={() => setFilter(!filter)}
                        className="com-search-area-large-filter btn-style"
                      >
                        <img
                          src={base_assets + "images/icons/filter.png"}
                          alt=""
                        />
                      </button>
                    </div>
                    <div
                      className={
                        parmissiondatashow?.pos_customer_reports?.Add
                          ? "customer-inner-tophead-right-custom d-flex"
                          : "d-none"
                      }
                    >
                      <button
                        className="cst-btn img-btn-hover"
                        onClick={() => {
                          setCusid();
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#customerAddModal"
                      >
                        <img
                          src={base_assets + "images/icons/adplus.png"}
                          className="img-btn-hover-img-1"
                          alt="filter"
                        />
                        <img
                          src={base_assets + "images/icons/adplus-w.png"}
                          className="img-btn-hover-img-2"
                          alt="filter"
                        />
                        {t("Customer")}
                      </button>
                      <Link
                        className="cst-btn img-btn-hover text-decoration-none"
                        to="/app/pos/appointment"
                      >
                        <img
                          src={base_assets + "images/icons/calendar-green.svg"}
                          className="img-btn-hover-img-1"
                          alt="icon"
                        />
                        <img
                          src={base_assets + "images/icons/white-calander.png"}
                          className="img-btn-hover-img-2"
                          alt="icon"
                        />
                        {t("Appointment")}
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="customer-inner-data">
                  <div className="search">
                    <div className="search-custom d-flex align-items-center">
                      <Select
                        className="limit-select short z-10"
                        options={selectOptions}
                        value={{ label: limit, value: limit }}
                        onChange={(e) => {
                          setLimit(e.value);
                          getlimit(e.value);
                        }}
                        isSearchable={false}
                      />
                    </div>
                    {/* <div className='data-set'>
                      <button className='db-btn' data-bs-toggle="modal"
                        data-bs-target="#ImportModal"><img src={base_assets + "images/icons/export.png"} className='' alt='export' /></button>
                    </div> */}
                  </div>
                  <div className="main-body-main-table-wrap vertical-scroll-table withdropdown customer-table-wrap">
                    <table
                      id="customer_table"
                      className="common-table first-row-gray w-100 customer-list-table"
                    >
                      <thead>
                        <tr>
                          {visibleColumns.map((col, idx) => {
                            const stickyClass =
                              idx < 4
                                ? `customer-sticky customer-sticky-${idx}`
                                : "";
                            const thClass = [col.class || "", stickyClass]
                              .filter(Boolean)
                              .join(" ");
                            if (col.name === "check_box") {
                              return (
                                <th
                                  key={`${col.name}-${idx}`}
                                  className={thClass}
                                >
                                  <div className="com-check">
                                    <input
                                      id="th_customer_list_checkbox"
                                      onClick={(e) =>
                                        handleSelectAllCheckBox(e)
                                      }
                                      className={(col.class || "").trim()}
                                      data-select={(col.class || "").trim()}
                                      type="checkbox"
                                    />
                                    <label
                                      htmlFor="th_customer_list_checkbox"
                                      className="com-check-label"
                                    />
                                  </div>
                                </th>
                              );
                            }
                            const sortClass =
                              sortState.column === col.name &&
                              sortState.dir === "desc"
                                ? "sort-desc"
                                : "";
                            return (
                              <th
                                key={`${col.name}-${idx}`}
                                className={thClass}
                                onClick={() => toggleCustomerSort(col)}
                                style={
                                  col.sort ? { cursor: "pointer" } : undefined
                                }
                              >
                                {t(col.lable)}
                                {col.sort ? (
                                  <div
                                    className={`up-down-arrow-btn ${sortClass}`}
                                  >
                                    <img
                                      className="up-down-arrow-img up-down-arrow-img-forward"
                                      src={
                                        base_assets +
                                        "images/icons/up-down-arrow.png"
                                      }
                                      alt=""
                                    />
                                    <img
                                      className="up-down-arrow-img up-down-arrow-img-reverse"
                                      src={
                                        base_assets +
                                        "images/icons/up-down-arrow-reverse.png"
                                      }
                                      alt=""
                                    />
                                  </div>
                                ) : null}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {sortedCustomerDetails?.length
                          ? sortedCustomerDetails.map((result, key) => (
                              <tr key={result?._id || key}>
                                {visibleColumns.map((col, cidx) => {
                                  const stickyClass =
                                    cidx < 4
                                      ? `customer-sticky customer-sticky-${cidx}`
                                      : "";
                                  const tdClass = stickyClass;
                                  switch (col.name) {
                                    case "check_box":
                                      return (
                                        <td key={col.name} className={tdClass}>
                                          <div className="com-check">
                                            <input
                                              id={result?._id}
                                              type="checkbox"
                                              className="poscustomertablehead"
                                            />
                                            <label
                                              htmlFor={result?._id}
                                              className="com-check-label"
                                            />
                                          </div>
                                        </td>
                                      );
                                    case "#":
                                      return (
                                        <td key={col.name} className={tdClass}>
                                          {key + 1}
                                        </td>
                                      );
                                    case "Img":
                                      return (
                                        <td key={col.name} className={tdClass}>
                                          <div className="pro-img">
                                            <img
                                              src={
                                                result?.profile
                                                  ? result?.profile
                                                  : base_assets +
                                                    "images/icons/customer-card-icon.png"
                                              }
                                              alt=""
                                            />
                                          </div>
                                        </td>
                                      );
                                    case "Customer Id": {
                                      const idStr =
                                        typeof result?.customerid === "string"
                                          ? result?.customerid
                                          : "";
                                      return (
                                        <td
                                          key={col.name}
                                          className={`customer-table-id-cell ${tdClass}`}
                                        >
                                          <span
                                            className="customer-table-truncate-inner"
                                            title={idStr || undefined}
                                          >
                                            {idStr}
                                          </span>
                                        </td>
                                      );
                                    }
                                    case "Name":
                                      return (
                                        <td
                                          key={col.name}
                                          className={`link-color cursor-pointer customer-table-name-cell ${tdClass}`}
                                          onClick={() => {
                                            setCusid(result?._id);
                                          }}
                                          data-bs-toggle="modal"
                                          data-bs-target="#customerAddModal"
                                          style={{overflow:'unset'}}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "10px",
                                              alignItems: "center",
                                            }}
                                          >
                                            <span
                                              className="customer-table-truncate-inner"
                                              title={result?.name || undefined}
                                            >
                                              {result?.name ? result?.name : ""}
                                            </span>
                                            {kycIntegrate === 1 && (
                                              <div>
                                                {" "}
                                                <span
                                                  onClick={() => {
                                                    handleKyc(result);
                                                  }}
                                                  style={{
                                                    color: "#000",
                                                    cursor:
                                                      !result?.kycStatus ||
                                                      result?.kycStatus !==
                                                        "Approved" ||
                                                      result?.kycStatus !==
                                                        "Completed"
                                                        ? "pointer"
                                                        : "default",
                                                    padding: "5px 0 0",
                                                    fontSize: "14px",
                                                    // textAlign:'center'
                                                  }}
                                                >
                                                  <KycStatusIcon
                                                    status={result?.kycStatus}
                                                    expireDate={
                                                      result?.kycExpireDate
                                                    }
                                                  />
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                        </td>
                                      );
                                    case "Group":
                                      return (
                                        <td
                                          key={col.name}
                                          className={`crown-img text-start d-flex justify-content-center gap-1 p-2 customer-table-group-cell ${tdClass}`}
                                        >
                                          {result?.group === "Silver" ? (
                                            <img
                                              className="group-crown"
                                              src={
                                                base_assets +
                                                "images/icons/silver-medal.png"
                                              }
                                              alt=""
                                            />
                                          ) : result?.group === "Gold" ? (
                                            <img
                                              className="group-crown"
                                              src={
                                                base_assets +
                                                "images/icons/gold-medal.png"
                                              }
                                              alt=""
                                            />
                                          ) : result?.group === "Platinum" ||
                                            result?.group === "Diamond" ? (
                                            <img
                                              className="group-crown"
                                              src={
                                                base_assets +
                                                "images/icons/platinum-medal.png"
                                              }
                                              alt=""
                                            />
                                          ) : (
                                            ""
                                          )}
                                          {result?.group}
                                        </td>
                                      );
                                    case "Mobile Number":
                                      return (
                                        <td key={col.name} className={tdClass}>
                                          {result?.phone ? result?.phone : ""}
                                        </td>
                                      );
                                    case "Email": {
                                      const emailStr = result?.email
                                        ? result.email
                                        : "";
                                      return (
                                        <td
                                          key={col.name}
                                          className={`customer-table-email-cell ${tdClass}`}
                                        >
                                          <span
                                            className="customer-table-truncate-inner"
                                            title={emailStr || undefined}
                                          >
                                            {emailStr}
                                          </span>
                                        </td>
                                      );
                                    }
                                    case "Last Modified Date":
                                      return (
                                        <td key={col.name} className={tdClass}>
                                          {result?.modified}
                                        </td>
                                      );
                                    case "Action":
                                      return (
                                        <td key={col.name} className={tdClass}>
                                          <div className="customer-table-dropdown dropdown">
                                            <button
                                              className="btn-style dropdown-toggle"
                                              type="button"
                                              data-table-action-btn
                                              onClick={(e) =>
                                                setActionMenu(
                                                  toggleTableActionMenu(
                                                    e,
                                                    result?._id,
                                                    { row: result },
                                                  ),
                                                )
                                              }
                                            >
                                              <img
                                                src={
                                                  base_assets +
                                                  "images/icons/ellipsis-circular.png"
                                                }
                                                alt=""
                                              />
                                            </button>
                                          </div>
                                        </td>
                                      );
                                    default:
                                      return (
                                        <td
                                          key={col.name || cidx}
                                          className={tdClass}
                                        />
                                      );
                                  }
                                })}
                              </tr>
                            ))
                          : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {customerdetails ? (
                <Pagination
                  total={totalPages}
                  current={currentPage}
                  pagination={(crPage) => handlePaginations(crPage)}
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="main-body-row-right-col">
            <CheckoutBlank />
          </div>
        </div>
      </div>
      <TableActionMenu menu={actionMenu} onClose={closeActionMenu}>
        {actionMenu ? (
          renderActionMenuItems(actionMenu.row)
        ) : null}
      </TableActionMenu>
      <TableColumnModal
        tablehead={poscustomer_head}
        tblName={"tbl_pos_customerlist"}
        setnewcolumndata={setnewcolumndata}
        calldatatable={GetcustomersDetails}
      ></TableColumnModal>
      <div className="confirmPopupHandler">
        <CustomerInformation cusid={cusid} setCusid={setCusid} />
      </div>
      {dataloder ? <Showloader /> : ""}
      <CustomerSearchDetailModal
        setnewcustomersid={setnewcustomersid}
        setCusid={setCusid}
      />
      <DeleteModal statement={"Customer"} handler_delete={handler_delete} />
      <Importmodal setImportfile={setImportfile} readExcel={readExcel} />
      <div
        className={
          filter
            ? "customer-search-filter-modal d-flex"
            : "customer-search-filter-modal"
        }
      >
        <div
          className="modal fade d-block"
          id="customerSearchFilterModal"
          aria-labelledby="customerSearchFilterModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  className="clear-btn btn-style link-color"
                  onClick={clearall}
                >
                  Clear All
                </button>
                <h5 className="modal-title" id="customerSearchFilterModalLabel">
                  Filter
                </h5>
                <button
                  type="button"
                  className="btn-close focus-none shadow-none"
                  onClick={() => setFilter(!filter)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="customer-search-filter-modal-row">
                  <div className="customer-search-filter-modal-row-col col">
                    <div className="customer-search-filter-modal-row-col-header">
                      <label className="customer-search-filter-modal-row-col-header-label">
                        Name
                      </label>
                      <button
                        className="customer-search-filter-modal-row-col-header-btn btn-style"
                        onClick={checkallName}
                      >
                        Select All
                      </button>
                    </div>
                    <div className="customer-search-filter-modal-row-col-body alphabates-box">
                      <div className="customer-search-filter-modal-row-col-body-check-data">
                        {alphabates.map((result, key) => {
                          return (
                            <div
                              key={key}
                              className="customer-search-filter-modal-row-col-body-check-data-single"
                            >
                              <div className="com-check">
                                <input
                                  type="checkbox"
                                  id={key}
                                  value={result}
                                  className="namescheck"
                                  name="clear"
                                  onClick={(e) => callfilters(e, "name")}
                                />
                                <label
                                  className="com-check-label"
                                  htmlFor={key}
                                ></label>
                              </div>
                              <label htmlFor={key}>{result}</label>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="customer-search-filter-modal-row-col col">
                    <div className="customer-search-filter-modal-row-col-header">
                      <label className="customer-search-filter-modal-row-col-header-label">
                        City
                      </label>
                      <button className="customer-search-filter-modal-row-col-header-btn btn-style">
                        Select All
                      </button>
                    </div>
                    <div className="customer-search-filter-modal-row-col-body">
                      <div className="customer-search-filter-modal-row-col-body-search">
                        <img
                          onClick={(e) => getscarchvalue(e, "city")}
                          className=""
                          src={
                            base_assets +
                            "images/pos/icons/magnifying-glass.png"
                          }
                          alt=""
                        />
                        <input
                          type="text"
                          placeholder="Search"
                          onKeyDown={(e) =>
                            e.key === "Enter" && getscarchvalue(e, "city")
                          }
                          onChange={(e) => setSearchVal(e.target.value)}
                        />
                      </div>
                      <div className="customer-search-filter-modal-row-col-body-check-data">
                        {city?.length
                          ? city.map((result, key) => {
                              return (
                                <div
                                  className="customer-search-filter-modal-row-col-body-check-data-single"
                                  key={key}
                                >
                                  <div className="com-check">
                                    <input
                                      type="checkbox"
                                      id={key + "city"}
                                      value={result || ""}
                                      name="clear"
                                      onClick={(e) => callfilters(e, "city")}
                                    />
                                    <label
                                      className="com-check-label"
                                      htmlFor={key + "city"}
                                    ></label>
                                  </div>
                                  <label htmlFor={"city" + key}>{result}</label>
                                </div>
                              );
                            })
                          : ""}
                      </div>
                    </div>
                  </div>
                  <div className="customer-search-filter-modal-row-col col">
                    <div className="customer-search-filter-modal-row-col-header">
                      <label className="customer-search-filter-modal-row-col-header-label">
                        Country
                      </label>
                      <button className="customer-search-filter-modal-row-col-header-btn btn-style">
                        Select All
                      </button>
                    </div>
                    <div className="customer-search-filter-modal-row-col-body">
                      <div className="customer-search-filter-modal-row-col-body-search">
                        <img
                          onClick={(e) => getscarchvalue(e, "country")}
                          className=""
                          src={
                            base_assets +
                            "images/pos/icons/magnifying-glass.png"
                          }
                          alt=""
                        />
                        <input
                          type="text"
                          placeholder="Search"
                          onKeyDown={(e) =>
                            e.key === "Enter" && getscarchvalue(e, "country")
                          }
                          onChange={(e) => setSearchVal(e.target.value)}
                        />
                      </div>
                      <div className="customer-search-filter-modal-row-col-body-check-data">
                        {country?.length
                          ? country.map((result, key) => {
                              return (
                                <div
                                  className="customer-search-filter-modal-row-col-body-check-data-single"
                                  key={key}
                                >
                                  <div className="com-check">
                                    <input
                                      type="checkbox"
                                      id={key + "country"}
                                      value={result?.id}
                                      name="clear"
                                      onClick={(e) => callfilters(e, "country")}
                                    />
                                    <label
                                      className="com-check-label"
                                      htmlFor={key + "country"}
                                    ></label>
                                  </div>
                                  <label htmlFor={key + "country"}>
                                    {result?.name ? result?.name : ""}
                                  </label>
                                </div>
                              );
                            })
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn-style"
                  onClick={() => {
                    setFilter(!filter);
                    GetcustomersDetails();
                  }}
                >
                  {t("Apply")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Customer;
